export default {
  contained: {
    backgroundColor: '#FFFFFF',
    boxShadow: 'none',
  },
}
